function CL_EnglishResources() {
    this.latestVerion = "Latest Version:";
    this.oldVersion = "Version:";
    this.forDesktop = "For Windows";
    this.getOnMobileDevices = "Get it on your mobile devices";
    this.viewPreviousVersions = "View Previous Versions";
    this.hidePreviousVersions = "Hide Previous Versions";
    var currentYear = (new Date()).getFullYear();
    this.footerCopyright = "&#169; " + currentYear + ". See <a href=\"https://www2.deloitte.com/content/www/ca/en/footerlinks1/legal.html\" target=\"_blank\">Terms of Use</a> for more information.";
    this.footerDeloitteMsg = "Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited, a UK private company limited by guarantee (\"DTTL\"), its network of member firms, and their related entities. DTTL and each of its member firms are legally separate and independent entities. DTTL (also referred to as \"Deloitte Global\") does not provide services to clients. Please see <a href=\"http://www.deloitte.com/about\" target=\"_blank\">www.deloitte.com/about</a> to learn more about our global network of member firms.";
    this.otherlanguage = "Fran&#231;ais";
    this.currentLanguage = "English";
    this.langKey = "EN";
    this.deloitteHomeLink = "http://www2.deloitte.com/ca/en.html";
    this.cleverantHomeLink = "https://www2.deloitte.com/ca/en/pages/consulting/solutions/CleverAnt.html";
    this.cleverantFooterLink = "https://www2.deloitte.com/ca/en/pages/about-deloitte/articles/about-deloitte-canada.html";
    //Fields
    this.versionDesc = "verionDescriptionEN";
    this.fileLinkDesc = "fileLinkDescriptionEN";
    this.fileUrl = "fileUrl";
    this.fileTypeName = "fileTypeName";
    this.downloadFileInfo = "downloadFileInfo";
    this.fileName = "fileName";
}

//© - &#169;
//à - &#224;
//é - &#233;
//« - &#171;
//» - &#187;
//è - &#232;
//ç - &#231;

function CL_FrenchResources() {
    this.latestVerion = "Derni&#232;re Version:";
    this.oldVersion = "Version:";
    this.forDesktop = "Pour Windows";
    this.getOnMobileDevices = "Obtenez-le sur vos appareils mobiles";
    this.viewPreviousVersions = "Afficher les versions pr&#233;c&#233;dentes";
    this.hidePreviousVersions = "Masquer les versions pr&#233;c&#233;dentes";
    var currentYear = (new Date()).getFullYear();
    this.footerCopyright = "&#169; " + currentYear + ". Consultez les <a href=\"https://www2.deloitte.com/content/www/ca/fr/footerlinks1/legal.html\" target=\"_blank\">conditions d'utilisation</a> pour obtenir plus de renseignements.";
    this.footerDeloitteMsg = "Deloitte d&#233;signe une ou plusieurs entit&#233;s parmi Deloitte Touche Tohmatsu Limited (DTTL), soci&#233;t&#233; ferm&#233;e &#224; responsabilit&#233; limit&#233;e par garanties du Royaume-Uni, ainsi que son r&#233;seau de cabinets membres dont chacun constitue une entit&#233; juridique distincte et ind&#233;pendante. DTTL (appel&#233; &#233;galement &#171; Deloitte mondial &#187;) n'offre aucun service aux clients.&nbsp;Veuillez consulter <a href=\"https://www2.deloitte.com/ca/fr/pages/about-deloitte/articles/about-deloitte.html\" target=\"_blank\">&#192; propos de Deloitte</a> afin d'en apprendre davantage sur notre r&#233;seau mondial de cabinets membres.";
    this.otherlanguage = "English";
    this.currentLanguage = "Fran&#231;ais";
    this.langKey = "FR";
    this.deloitteHomeLink = "http://www2.deloitte.com/ca/fr.html";
    this.cleverantHomeLink = "https://www2.deloitte.com/ca/fr/pages/consulting/solutions/CleverAnt.html";
    this.cleverantFooterLink = "https://www2.deloitte.com/ca/fr/pages/apropos-deloitte/articles/apropos-deloitte-canada.html";
    //Fields
    this.versionDesc = "verionDescriptionFR";
    this.fileLinkDesc = "fileLinkDescriptionFR";
    this.fileUrl = "fileUrl";
    this.fileTypeName = "fileTypeName";
    this.downloadFileInfo = "downloadFileInfo";
}

export function GetResources(lang) {
    var language = lang || GetLanguage();
    if (language == "EN") {
        return new CL_EnglishResources();
    }
    else {
        return new CL_FrenchResources();
    }
}

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (valueToFind, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(valueToFind, elementK) is true, return true.
                if (sameValueZero(o[k], valueToFind)) {
                    return true;
                }
                // c. Increase k by 1. 
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, 'includes', {
        value: function (search, start) {
            if (typeof start !== 'number') {
                start = 0
            }

            if (start + search.length > this.length) {
                return false
            } else {
                return this.indexOf(search, start) !== -1
            }
        }
    })
}

if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        value: function (value) {

            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);

            // Steps 3-5.
            var len = O.length >>> 0;

            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;

            // Step 8.
            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ?
                len : end >> 0;

            // Step 11.
            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            // Step 12.
            while (k < final) {
                O[k] = value;
                k++;
            }

            // Step 13.
            return O;
        }
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

///Updates lang query string in URL
export function updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }
    return uri + hash;  // finally append the hash as well
}

function getQueryStringValue(key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}


function GetLanguage() {
    var language = getQueryStringValue('lang') || getQueryStringValue('LANG') || getQueryStringValue('Lang') || GetBrowserLanguage();
    return language.indexOf('-') ? language.split('-')[0].toUpperCase() : language.toUpperCase();
}

function GetBrowserLanguage() {
    var x;
    if (navigator.languages != undefined)
        x = navigator.languages[0];
    else
        x = (navigator.language || navigator.userLanguage);

    return x;
}

export function convertDateToUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}